import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowUpRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconArrowUpRight"><Path fillRule="evenodd" clipRule="evenodd" d="M8 6C8 5.44772 8.44772 5 9 5H18C18.5523 5 19 5.44772 19 6V15C19 15.5523 18.5523 16 18 16C17.4477 16 17 15.5523 17 15V8.41421L6.95711 18.4571C6.56658 18.8476 5.93342 18.8476 5.54289 18.4571C5.15237 18.0666 5.15237 17.4334 5.54289 17.0429L15.5858 7H9C8.44772 7 8 6.55228 8 6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowUpRight;
